export async function all({ types }) {
  const response = await this.get(`/blobs?types=${types}`);

  return response;
}

export async function update({ id, data, type, silent, keepalive }) {
  // `keepalive` makes the save survive a page unload (e.g. an immediate reload right after
  // navigating) — used by the navigation-state save. `silent` (non-keepalive path) opts out
  // of navigate-on-error for background saves, same as AuthAPI.ping.
  if (keepalive) {
    return this.patchWithKeepalive(`/blobs/${id}`, { blob: { data, type } });
  }

  return this.patch(`/blobs/${id}`, { blob: { data, type } }, {}, { silent });
}

export async function destroy({ id }) {
  const response = await this.delete(`/blobs/${id}`);

  return response;
}
